module.exports = __webpack_public_path__ + "static/img/edward&cardy.8a318d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/edward&cardy.png
// module id = 485
// module chunks = 2